import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-home" */ `./views/Home.vue`),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: "home.title"
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-settings" */ "./views/settings/DefinitionsDetails.vue"),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: "settings.titles"
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-print_visible_emissions" */ "./views/print/PrintVisibleBase.vue"),
        children: [
            {
                path: "config",
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-print_visible_emissions" */ "./views/print/PrintVisibleConfig.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: "print_visible_emissions.title"
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: "print_visible_emissions.title"
        }
    },
    {
        path: `/${apiConstants.code}/defaultlayers`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.default_layers`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-layers" */ "./views/layer/LayerBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.layers`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-layers" */ "./views/layer/LayerList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.titles`
                }
            },
            {
                path: ":type",
                name: `${apiConstants.code}.layers.create`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-layers" */ "./views/layer/LayerDetails.vue"),
                beforeEnter: (to, from, next) => {
                    let available = ["group", "resource"];
                    if (available.indexOf(to.params.type) == -1) {
                        next(false);
                    } else {
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`
                }
            },
            {
                path: "group/:id",
                name: `${apiConstants.code}.layers.show.group`,
                props: { isLayer: false },
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-layers" */ "./views/layer/LayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`
                }
            },
            {
                path: "resource/:id",
                name: `${apiConstants.code}.layers.show.item`,
                props: { isLayer: true },
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-layers" */ "./views/layer/LayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `layers.titles`
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regulations" */ "./views/regulation/RegulationBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.regulations`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regulations" */ "./views/regulation/RegulationList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.titles`
                }
            },
            {
                path: ":type",
                name: `${apiConstants.code}.regulations.create`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                beforeEnter: (to, from, next) => {
                    let available = ["group", "item"];
                    if (available.indexOf(to.params.type) == -1) {
                        next(false);
                    } else {
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            },
            {
                path: "group/:id",
                name: `${apiConstants.code}.regulations.show.group`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            },
            {
                path: "item/:id",
                name: `${apiConstants.code}.regulations.show.item`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `regulations.titles`
        }
    },

    {
        path: `/${apiConstants.code}/classificationtypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-classificationtypes" */ "./views/classificationtypes/ClassificationTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.classification_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-classificationtypes" */ "./views/classificationtypes/ClassificationTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `classification_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.classification_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-classificationtypes" */ "./views/classificationtypes/ClassificationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `classification_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.classification_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-classificationtypes" */ "./views/classificationtypes/ClassificationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `classification_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `classification_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/constructiontypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-constructiontypes" */ "./views/constructiontypes/ConstructionTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.construction_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-constructiontypes" */ "./views/constructiontypes/ConstructionTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `construction_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.construction_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-constructiontypes" */ "./views/constructiontypes/ConstructionTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `construction_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.construction_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-constructiontypes" */ "./views/constructiontypes/ConstructionTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `construction_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `construction_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/ordertypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-ordertypes" */ "./views/ordertypes/OrderTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.order_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-ordertypes" */ "./views/ordertypes/OrderTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `order_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.order_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-ordertypes" */ "./views/ordertypes/OrderTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `order_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.order_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-ordertypes" */ "./views/ordertypes/OrderTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `order_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `order_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/proceduretypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-proceduretypes" */ "./views/proceduretypes/ProcedureTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.procedure_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-proceduretypes" */ "./views/proceduretypes/ProcedureTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `procedure_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.procedure_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-proceduretypes" */ "./views/proceduretypes/ProcedureTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `procedure_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.procedure_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-proceduretypes" */ "./views/proceduretypes/ProcedureTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `procedure_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `procedure_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/limittypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-limittypes" */ "./views/limittypes/LimitTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.limit_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-limittypes" */ "./views/limittypes/LimitTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `limit_types.titles`
                }
            },
            {
                path: "config",
                name: `${apiConstants.code}.limit_types.config`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-limittypes" */ "./views/limittypes/LimitTypeConfig.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `limit_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.limit_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-limittypes" */ "./views/limittypes/LimitTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `limit_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.limit_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-limittypes" */ "./views/limittypes/LimitTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `limit_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `limit_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/usetypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-usetypes" */ "./views/usetypes/UseTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.use_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-usetypes" */ "./views/usetypes/UseTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `use_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.use_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-usetypes" */ "./views/usetypes/UseTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `use_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.use_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-usetypes" */ "./views/usetypes/UseTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `use_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `use_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/regimetypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regimetypes" */ "./views/regimetypes/RegimeTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.regime_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regimetypes" */ "./views/regimetypes/RegimeTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regime_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.regime_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regimetypes" */ "./views/regimetypes/RegimeTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regime_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.regime_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-regimetypes" */ "./views/regimetypes/RegimeTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regime_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `regime_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/statuses`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-statuses" */ "./views/statuses/StatusBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.statuses`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-statuses" */ "./views/statuses/StatusList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `statuses.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.statuses.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-statuses" */ "./views/statuses/StatusDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `statuses.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.statuses.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-statuses" */ "./views/statuses/StatusDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `statuses.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `statuses.titles`
        }
    },
    {
        path: `/${apiConstants.code}/states`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-states" */ "./views/states/StateBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.states`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-states" */ "./views/states/StateList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `states.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.states.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-states" */ "./views/states/StateDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `states.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.states.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-states" */ "./views/states/StateDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `states.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `states.titles`
        }
    },
    {
        path: `/${apiConstants.code}/sourcetypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-sourcetypes" */ "./views/sourcetypes/SourceTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.source_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-sourcetypes" */ "./views/sourcetypes/SourceTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `source_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.source_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-sourcetypes" */ "./views/sourcetypes/SourceTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `source_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.source_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-sourcetypes" */ "./views/sourcetypes/SourceTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `source_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `source_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/documenttypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-documenttypes" */ "./views/documenttypes/DocumentTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.document_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-documenttypes" */ "./views/documenttypes/DocumentTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.document_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-documenttypes" */ "./views/documenttypes/DocumentTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.document_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-documenttypes" */ "./views/documenttypes/DocumentTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `document_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/entities`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-entities" */ "./views/entities/EntityBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.entities`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-entities" */ "./views/entities/EntityList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `entities.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.entities.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-entities" */ "./views/entities/EntityDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `entities.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.entities.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-entities" */ "./views/entities/EntityDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `entities.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `entities.titles`
        }
    },
    {
        path: `/${apiConstants.code}/confrontations`,
        name: `${apiConstants.code}.confrontations`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-confrontations" */ "./views/confrontations/ConfrontationsBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.confrontations`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-confrontations" */ "./views/confrontations/ConfrontationsList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `confrontations.titles`
                }
            },
            {
                path: "config",
                name: `${apiConstants.code}.confrontations.config`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-map" */ "./views/confrontations/ConfrontationsConfig.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `confrontations.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.confrontations.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-confrontations" */ "./views/confrontations/ConfrontationsDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `confrontations.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.confrontations.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-confrontations" */ "./views/confrontations/ConfrontationsDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `confrontations.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: "confrontations.title"
        }
    },
    {
        path: `/${apiConstants.code}/matrixclassificationtypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-matrixclassificationtypes" */ "./views/matrixclassificationtypes/matrixClassificationTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.matrix_classification_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-matrixclassificationtypes" */ "./views/matrixclassificationtypes/matrixClassificationTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `matrix_classification_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.matrix_classification_types.create`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-matrixclassificationtypes" */ "./views/matrixclassificationtypes/matrixClassificationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `matrix_classification_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.matrix_classification_types.show`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-matrixclassificationtypes" */ "./views/matrixclassificationtypes/matrixClassificationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `matrix_classification_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `matrix_classification_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/licensetypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-licensetypes" */ "./views/licensetypes/LicenseTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.license_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-licensetypes" */ "./views/licensetypes/LicenseTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.license_types.create`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-licensetypes" */ "./views/licensetypes/LicenseTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.license_types.show`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "gugestao-licensetypes" */ "./views/licensetypes/LicenseTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_types.titles`
        }
    }
];

export default routes;
